import { serverErrorCode } from '@tallo/design-system';

import { closedInviteErrorCodes } from '../interfaces/team-invite.dto';

/** The invite was accepted, revoked or ran out while the accept page was open. */
export function isClosedInviteError(error: unknown): boolean {
  return closedInviteErrorCodes.includes(serverErrorCode(error) ?? '');
}
